<template>
  <section>
    <div class="container">
      <div class="c-boxcontainer__header">
        <h1 class="c-boxcontainer__title">{{$t('homepage.box-container.title')}}</h1>
        <h2 class="c-boxcontainer__subtitle">{{$t('homepage.box-container.subtitle')}}</h2>
      </div>
      <div class="c-boxcontainer__content">
        <template v-for="(box,index) in boxes">
          <Box v-bind:key="index" v-bind:title="box.title" v-bind:number="box.number"></Box>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import Box from "./Box";

export default {
  components: {
    Box
  },
  data() {
    return {
      boxes: [
        {
          title: "Accedi e registrati alla piattaforma",
          subtitle: "",
          number: "1"
        },
        {
          title: "Partecipa alle missioni",
          subtitle: "",
          number: "2"
        },
        {
          title: "Accumula punti e scala la classifica",
          subtitle: "",
          number: "3"
        },
        {
          title: "Vivi un’esperienza unica con FIR",
          subtitle: "",
          number: "4"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins.scss";

.c-boxcontainer__header {
  text-align: center;
  margin: 2rem 0;
  @include lg {
    margin: 5rem auto;
  }
}
.c-boxcontainer__content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 3rem;
  @include lg {
    flex-direction: row;
  }
}
.c-boxcontainer__title {
  font-size: 32px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  @include lg {
    font-size: 45px;
  }
}

.c-boxcontainer__subtitle {
  font-size: 24px;
  line-height: 1.22;
  letter-spacing: 1.8px;
  font-weight: 400;
  @include lg {
    font-size: 45px;
  }
}
</style>
